<template lang="html">

  <div class="candidaturas">
    <div class="contenedor-candidaturas">
      <template v-if="!loading">
        <candidatura :data="candidatura" :key="key" v-for="(candidatura,key) in candidaturas.slice(0,5)" v-if="candidaturas.length != 0"></candidatura>
        <p class="zero-result" v-if="candidaturas.length == 0">Aún no tienes candidaturas</p>
      </template>
      <div v-else class="view-loading -small"></div>
    </div>
    <router-link class="link" :to="$t('enlaces.candidaturas')" v-if="candidaturas.length != 0">Ver más</router-link>
  </div>



</template>

<script lang="js">

  import candidatura from '@/components/view-parts/home/candidatura-el';

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'candidaturas-home',
    mounted(){
            if(!!!this.candidaturas){   
                this.loading = true;
                this.requestCandidaturas().then(r => {
                  this.loading = false;
                });
            }
    },
    methods : {
            ...mapActions(['requestCandidaturas'])
    },
    data(){
      return{
        loading : false
      }
    },
    components: {
      'candidatura': candidatura
    },
    computed : {
            ...mapGetters({
                isEstudiante : 'isEstudiante',
                candidaturas : 'getCandidaturas'
            })
        }
  }
</script>

<style scoped lang="scss">
.candidaturas {
  text-align: left;
}

.zero-result{
  margin-top: 20px;
  padding-left: 25px;
  display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/candidaturas.vue